import { render, staticRenderFns } from "./exerciseQuestionBankConfig.vue?vue&type=template&id=72534290&scoped=true"
import script from "./exerciseQuestionBankConfig.vue?vue&type=script&lang=js"
export * from "./exerciseQuestionBankConfig.vue?vue&type=script&lang=js"
import style0 from "./exerciseQuestionBankConfig.vue?vue&type=style&index=0&id=72534290&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72534290",
  null
  
)

export default component.exports